import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import Markdown from 'react-markdown';

const TermsOfUse = () => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const docRef = doc(db, 'legal', 'texts');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists() && docSnap.data().termsOfUse) {
          setContent(docSnap.data().termsOfUse);
        } else {
          // Fallback content
          setContent(`
# Termos de Uso - UNIFIG

Bem-vindo ao site oficial da UNIFIG (União dos Deficientes Físicos de Iguatemi). Ao acessar este site, você concorda em cumprir estes termos de uso.

## 1. Aceitação dos Termos
O acesso e uso deste site estão sujeitos aos seguintes termos e condições e a todas as leis aplicáveis.

## 2. Uso do Conteúdo
Todo o conteúdo deste site (textos, imagens, logotipos) é de propriedade da UNIFIG ou utilizado com permissão. É proibida a reprodução para fins comerciais sem autorização prévia.

## 3. Responsabilidades do Usuário
O usuário compromete-se a utilizar o site de forma lícita, não enviando mensagens ofensivas ou tentando comprometer a segurança do sistema.

## 4. Limitação de Responsabilidade
A UNIFIG busca manter as informações atualizadas, mas não se responsabiliza por eventuais erros técnicos ou indisponibilidade temporária do site.

## 5. Alterações nos Termos
Reservamo-nos o direito de alterar estes termos a qualquer momento. Recomendamos a consulta periódica desta página.

## 6. Foro
Fica eleito o foro da comarca de Iguatemi - MS para dirimir quaisquer questões relativas a estes termos.
          `);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <main>
      <PageHeader title="Termos de Uso" description="Regras e diretrizes para a utilização do site institucional da UNIFIG." />
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate prose-blue max-w-none">
            {loading ? (
              <div className="animate-pulse space-y-4">
                <div className="h-8 bg-slate-100 rounded w-1/2" />
                <div className="h-4 bg-slate-100 rounded w-full" />
                <div className="h-4 bg-slate-100 rounded w-full" />
                <div className="h-4 bg-slate-100 rounded w-3/4" />
              </div>
            ) : (
              <Markdown>{content}</Markdown>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsOfUse;
